/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as R403RouteImport } from './routes/403'
import { Route as R404RouteImport } from './routes/404'
import { Route as R500RouteImport } from './routes/500'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OfflineRouteImport } from './routes/offline'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AppApplicationsRouteImport } from './routes/app.applications'
import { Route as AppCommerceRouteImport } from './routes/app.commerce'
import { Route as AppFeedbacksRouteImport } from './routes/app.feedbacks'
import { Route as AppUpgradeCenterRouteImport } from './routes/app.upgrade-center'
import { Route as AppUsersRouteImport } from './routes/app.users'
import { Route as ProfileBasicRouteImport } from './routes/profile.basic'
import { Route as ProfileConnectionsRouteImport } from './routes/profile.connections'
import { Route as ProfileSecurityRouteImport } from './routes/profile.security'
import { Route as AppContentArticlesRouteImport } from './routes/app.content.articles'
import { Route as AppContentCategoriesRouteImport } from './routes/app.content.categories'
import { Route as AppContentPagesRouteImport } from './routes/app.content.pages'
import { Route as AppSupportCharactersRouteImport } from './routes/app.support.characters'
import { Route as AppSupportFaqRouteImport } from './routes/app.support.faq'
import { Route as AppSupportInboxRouteImport } from './routes/app.support.inbox'
import { Route as AppSupportProductsRouteImport } from './routes/app.support.products'
import { Route as AppSupportSettingsRouteImport } from './routes/app.support.settings'
import { Route as AppSupportSitesRouteImport } from './routes/app.support.sites'
import { Route as AuthCallbackProviderRouteImport } from './routes/auth.callback.$provider'
import { Route as SystemAccessMenusRouteImport } from './routes/system.access.menus'
import { Route as SystemAccessPermissionsRouteImport } from './routes/system.access.permissions'
import { Route as SystemAccessRolesRouteImport } from './routes/system.access.roles'
import { Route as SystemAiAccessRouteImport } from './routes/system.ai.access'
import { Route as SystemAiModelsRouteImport } from './routes/system.ai.models'
import { Route as SystemAiPlaygroundRouteImport } from './routes/system.ai.playground'
import { Route as SystemAiProvidersRouteImport } from './routes/system.ai.providers'
import { Route as SystemAiUsageRouteImport } from './routes/system.ai.usage'
import { Route as SystemContentArticlesRouteImport } from './routes/system.content.articles'
import { Route as SystemContentCategoriesRouteImport } from './routes/system.content.categories'
import { Route as SystemIntegrationsApiClientsRouteImport } from './routes/system.integrations.api-clients'
import { Route as SystemIntegrationsSchedulesRouteImport } from './routes/system.integrations.schedules'
import { Route as SystemIntegrationsWebhooksRouteImport } from './routes/system.integrations.webhooks'
import { Route as SystemMobileReleasesRouteImport } from './routes/system.mobile.releases'
import { Route as SystemMonitoringHealthRouteImport } from './routes/system.monitoring.health'
import { Route as SystemMonitoringSessionsRouteImport } from './routes/system.monitoring.sessions'
import { Route as SystemNotificationsDeliveriesRouteImport } from './routes/system.notifications.deliveries'
import { Route as SystemNotificationsMessagesRouteImport } from './routes/system.notifications.messages'
import { Route as SystemNotificationsNoticesRouteImport } from './routes/system.notifications.notices'
import { Route as SystemNotificationsOperationsRouteImport } from './routes/system.notifications.operations'
import { Route as SystemNotificationsPushChannelsRouteImport } from './routes/system.notifications.push-channels'
import { Route as SystemNotificationsTemplatesRouteImport } from './routes/system.notifications.templates'
import { Route as SystemSecurityBlockRulesRouteImport } from './routes/system.security.block-rules'
import { Route as SystemSecurityEventsRouteImport } from './routes/system.security.events'
import { Route as SystemSecurityLoginLogsRouteImport } from './routes/system.security.login-logs'
import { Route as SystemSecurityOperationLogsRouteImport } from './routes/system.security.operation-logs'
import { Route as SystemSettingsConfigsRouteImport } from './routes/system.settings.configs'
import { Route as SystemSettingsDictionariesRouteImport } from './routes/system.settings.dictionaries'
import { Route as SystemSettingsLoginProvidersRouteImport } from './routes/system.settings.login-providers'
import { Route as SystemSettingsRegionsRouteImport } from './routes/system.settings.regions'
import { Route as SystemSettingsShareConfigsRouteImport } from './routes/system.settings.share-configs'
import { Route as SystemStorageFilesRouteImport } from './routes/system.storage.files'
import { Route as SystemUsersAccountsRouteImport } from './routes/system.users.accounts'
import { Route as SystemUsersDepartmentsRouteImport } from './routes/system.users.departments'
import { Route as SystemUsersPositionsRouteImport } from './routes/system.users.positions'
import { Route as SystemUsersTenantsRouteImport } from './routes/system.users.tenants'
import { Route as SystemAccessRolesIndexRouteImport } from './routes/system.access.roles.index'
import { Route as SystemAccessRolesRoleIdRouteImport } from './routes/system.access.roles.$roleId'
import { Route as SystemIntegrationsApiClientsIndexRouteImport } from './routes/system.integrations.api-clients.index'
import { Route as SystemIntegrationsApiClientsClientIdRouteImport } from './routes/system.integrations.api-clients.$clientId'
import { Route as SystemIntegrationsSchedulesIndexRouteImport } from './routes/system.integrations.schedules.index'
import { Route as SystemNotificationsMessagesIndexRouteImport } from './routes/system.notifications.messages.index'
import { Route as SystemNotificationsMessagesMessageIdRouteImport } from './routes/system.notifications.messages.$messageId'
import { Route as SystemNotificationsNoticesIndexRouteImport } from './routes/system.notifications.notices.index'
import { Route as SystemNotificationsNoticesNoticeIdRouteImport } from './routes/system.notifications.notices.$noticeId'
import { Route as SystemSecurityEventsIndexRouteImport } from './routes/system.security.events.index'
import { Route as SystemSecurityEventsEventIdRouteImport } from './routes/system.security.events.$eventId'
import { Route as SystemStorageFilesIndexRouteImport } from './routes/system.storage.files.index'
import { Route as SystemStorageFilesFileIdRouteImport } from './routes/system.storage.files.$fileId'
import { Route as SystemUsersAccountsIndexRouteImport } from './routes/system.users.accounts.index'
import { Route as SystemUsersAccountsUserIdRouteImport } from './routes/system.users.accounts.$userId'
import { Route as SystemUsersTenantsIndexRouteImport } from './routes/system.users.tenants.index'
import { Route as SystemUsersTenantsTenantIdRouteImport } from './routes/system.users.tenants.$tenantId'
import { Route as SystemIntegrationsSchedulesScheduleIdRunsRouteImport } from './routes/system.integrations.schedules.$scheduleId.runs'
import { Route as SystemIntegrationsWebhooksWebhookIdDeliveriesRouteImport } from './routes/system.integrations.webhooks.$webhookId.deliveries'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const R500Route = R500RouteImport.update({
  id: '/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OfflineRoute = OfflineRouteImport.update({
  id: '/offline',
  path: '/offline',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppApplicationsRoute = AppApplicationsRouteImport.update({
  id: '/app/applications',
  path: '/app/applications',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCommerceRoute = AppCommerceRouteImport.update({
  id: '/app/commerce',
  path: '/app/commerce',
  getParentRoute: () => rootRouteImport,
} as any)
const AppFeedbacksRoute = AppFeedbacksRouteImport.update({
  id: '/app/feedbacks',
  path: '/app/feedbacks',
  getParentRoute: () => rootRouteImport,
} as any)
const AppUpgradeCenterRoute = AppUpgradeCenterRouteImport.update({
  id: '/app/upgrade-center',
  path: '/app/upgrade-center',
  getParentRoute: () => rootRouteImport,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/app/users',
  path: '/app/users',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileBasicRoute = ProfileBasicRouteImport.update({
  id: '/profile/basic',
  path: '/profile/basic',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileConnectionsRoute = ProfileConnectionsRouteImport.update({
  id: '/profile/connections',
  path: '/profile/connections',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileSecurityRoute = ProfileSecurityRouteImport.update({
  id: '/profile/security',
  path: '/profile/security',
  getParentRoute: () => rootRouteImport,
} as any)
const AppContentArticlesRoute = AppContentArticlesRouteImport.update({
  id: '/app/content/articles',
  path: '/app/content/articles',
  getParentRoute: () => rootRouteImport,
} as any)
const AppContentCategoriesRoute = AppContentCategoriesRouteImport.update({
  id: '/app/content/categories',
  path: '/app/content/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const AppContentPagesRoute = AppContentPagesRouteImport.update({
  id: '/app/content/pages',
  path: '/app/content/pages',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSupportCharactersRoute = AppSupportCharactersRouteImport.update({
  id: '/app/support/characters',
  path: '/app/support/characters',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSupportFaqRoute = AppSupportFaqRouteImport.update({
  id: '/app/support/faq',
  path: '/app/support/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSupportInboxRoute = AppSupportInboxRouteImport.update({
  id: '/app/support/inbox',
  path: '/app/support/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSupportProductsRoute = AppSupportProductsRouteImport.update({
  id: '/app/support/products',
  path: '/app/support/products',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSupportSettingsRoute = AppSupportSettingsRouteImport.update({
  id: '/app/support/settings',
  path: '/app/support/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSupportSitesRoute = AppSupportSitesRouteImport.update({
  id: '/app/support/sites',
  path: '/app/support/sites',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackProviderRoute = AuthCallbackProviderRouteImport.update({
  id: '/auth/callback/$provider',
  path: '/auth/callback/$provider',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemAccessMenusRoute = SystemAccessMenusRouteImport.update({
  id: '/system/access/menus',
  path: '/system/access/menus',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemAccessPermissionsRoute = SystemAccessPermissionsRouteImport.update({
  id: '/system/access/permissions',
  path: '/system/access/permissions',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemAccessRolesRoute = SystemAccessRolesRouteImport.update({
  id: '/system/access/roles',
  path: '/system/access/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemAiAccessRoute = SystemAiAccessRouteImport.update({
  id: '/system/ai/access',
  path: '/system/ai/access',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemAiModelsRoute = SystemAiModelsRouteImport.update({
  id: '/system/ai/models',
  path: '/system/ai/models',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemAiPlaygroundRoute = SystemAiPlaygroundRouteImport.update({
  id: '/system/ai/playground',
  path: '/system/ai/playground',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemAiProvidersRoute = SystemAiProvidersRouteImport.update({
  id: '/system/ai/providers',
  path: '/system/ai/providers',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemAiUsageRoute = SystemAiUsageRouteImport.update({
  id: '/system/ai/usage',
  path: '/system/ai/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemContentArticlesRoute = SystemContentArticlesRouteImport.update({
  id: '/system/content/articles',
  path: '/system/content/articles',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemContentCategoriesRoute = SystemContentCategoriesRouteImport.update({
  id: '/system/content/categories',
  path: '/system/content/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemIntegrationsApiClientsRoute =
  SystemIntegrationsApiClientsRouteImport.update({
    id: '/system/integrations/api-clients',
    path: '/system/integrations/api-clients',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemIntegrationsSchedulesRoute =
  SystemIntegrationsSchedulesRouteImport.update({
    id: '/system/integrations/schedules',
    path: '/system/integrations/schedules',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemIntegrationsWebhooksRoute =
  SystemIntegrationsWebhooksRouteImport.update({
    id: '/system/integrations/webhooks',
    path: '/system/integrations/webhooks',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemMobileReleasesRoute = SystemMobileReleasesRouteImport.update({
  id: '/system/mobile/releases',
  path: '/system/mobile/releases',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemMonitoringHealthRoute = SystemMonitoringHealthRouteImport.update({
  id: '/system/monitoring/health',
  path: '/system/monitoring/health',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemMonitoringSessionsRoute =
  SystemMonitoringSessionsRouteImport.update({
    id: '/system/monitoring/sessions',
    path: '/system/monitoring/sessions',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemNotificationsDeliveriesRoute =
  SystemNotificationsDeliveriesRouteImport.update({
    id: '/system/notifications/deliveries',
    path: '/system/notifications/deliveries',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemNotificationsMessagesRoute =
  SystemNotificationsMessagesRouteImport.update({
    id: '/system/notifications/messages',
    path: '/system/notifications/messages',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemNotificationsNoticesRoute =
  SystemNotificationsNoticesRouteImport.update({
    id: '/system/notifications/notices',
    path: '/system/notifications/notices',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemNotificationsOperationsRoute =
  SystemNotificationsOperationsRouteImport.update({
    id: '/system/notifications/operations',
    path: '/system/notifications/operations',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemNotificationsPushChannelsRoute =
  SystemNotificationsPushChannelsRouteImport.update({
    id: '/system/notifications/push-channels',
    path: '/system/notifications/push-channels',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemNotificationsTemplatesRoute =
  SystemNotificationsTemplatesRouteImport.update({
    id: '/system/notifications/templates',
    path: '/system/notifications/templates',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemSecurityBlockRulesRoute =
  SystemSecurityBlockRulesRouteImport.update({
    id: '/system/security/block-rules',
    path: '/system/security/block-rules',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemSecurityEventsRoute = SystemSecurityEventsRouteImport.update({
  id: '/system/security/events',
  path: '/system/security/events',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemSecurityLoginLogsRoute = SystemSecurityLoginLogsRouteImport.update({
  id: '/system/security/login-logs',
  path: '/system/security/login-logs',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemSecurityOperationLogsRoute =
  SystemSecurityOperationLogsRouteImport.update({
    id: '/system/security/operation-logs',
    path: '/system/security/operation-logs',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemSettingsConfigsRoute = SystemSettingsConfigsRouteImport.update({
  id: '/system/settings/configs',
  path: '/system/settings/configs',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemSettingsDictionariesRoute =
  SystemSettingsDictionariesRouteImport.update({
    id: '/system/settings/dictionaries',
    path: '/system/settings/dictionaries',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemSettingsLoginProvidersRoute =
  SystemSettingsLoginProvidersRouteImport.update({
    id: '/system/settings/login-providers',
    path: '/system/settings/login-providers',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemSettingsRegionsRoute = SystemSettingsRegionsRouteImport.update({
  id: '/system/settings/regions',
  path: '/system/settings/regions',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemSettingsShareConfigsRoute =
  SystemSettingsShareConfigsRouteImport.update({
    id: '/system/settings/share-configs',
    path: '/system/settings/share-configs',
    getParentRoute: () => rootRouteImport,
  } as any)
const SystemStorageFilesRoute = SystemStorageFilesRouteImport.update({
  id: '/system/storage/files',
  path: '/system/storage/files',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemUsersAccountsRoute = SystemUsersAccountsRouteImport.update({
  id: '/system/users/accounts',
  path: '/system/users/accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemUsersDepartmentsRoute = SystemUsersDepartmentsRouteImport.update({
  id: '/system/users/departments',
  path: '/system/users/departments',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemUsersPositionsRoute = SystemUsersPositionsRouteImport.update({
  id: '/system/users/positions',
  path: '/system/users/positions',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemUsersTenantsRoute = SystemUsersTenantsRouteImport.update({
  id: '/system/users/tenants',
  path: '/system/users/tenants',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemAccessRolesIndexRoute = SystemAccessRolesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SystemAccessRolesRoute,
} as any)
const SystemAccessRolesRoleIdRoute = SystemAccessRolesRoleIdRouteImport.update({
  id: '/$roleId',
  path: '/$roleId',
  getParentRoute: () => SystemAccessRolesRoute,
} as any)
const SystemIntegrationsApiClientsIndexRoute =
  SystemIntegrationsApiClientsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SystemIntegrationsApiClientsRoute,
  } as any)
const SystemIntegrationsApiClientsClientIdRoute =
  SystemIntegrationsApiClientsClientIdRouteImport.update({
    id: '/$clientId',
    path: '/$clientId',
    getParentRoute: () => SystemIntegrationsApiClientsRoute,
  } as any)
const SystemIntegrationsSchedulesIndexRoute =
  SystemIntegrationsSchedulesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SystemIntegrationsSchedulesRoute,
  } as any)
const SystemNotificationsMessagesIndexRoute =
  SystemNotificationsMessagesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SystemNotificationsMessagesRoute,
  } as any)
const SystemNotificationsMessagesMessageIdRoute =
  SystemNotificationsMessagesMessageIdRouteImport.update({
    id: '/$messageId',
    path: '/$messageId',
    getParentRoute: () => SystemNotificationsMessagesRoute,
  } as any)
const SystemNotificationsNoticesIndexRoute =
  SystemNotificationsNoticesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SystemNotificationsNoticesRoute,
  } as any)
const SystemNotificationsNoticesNoticeIdRoute =
  SystemNotificationsNoticesNoticeIdRouteImport.update({
    id: '/$noticeId',
    path: '/$noticeId',
    getParentRoute: () => SystemNotificationsNoticesRoute,
  } as any)
const SystemSecurityEventsIndexRoute =
  SystemSecurityEventsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SystemSecurityEventsRoute,
  } as any)
const SystemSecurityEventsEventIdRoute =
  SystemSecurityEventsEventIdRouteImport.update({
    id: '/$eventId',
    path: '/$eventId',
    getParentRoute: () => SystemSecurityEventsRoute,
  } as any)
const SystemStorageFilesIndexRoute = SystemStorageFilesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SystemStorageFilesRoute,
} as any)
const SystemStorageFilesFileIdRoute =
  SystemStorageFilesFileIdRouteImport.update({
    id: '/$fileId',
    path: '/$fileId',
    getParentRoute: () => SystemStorageFilesRoute,
  } as any)
const SystemUsersAccountsIndexRoute =
  SystemUsersAccountsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SystemUsersAccountsRoute,
  } as any)
const SystemUsersAccountsUserIdRoute =
  SystemUsersAccountsUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => SystemUsersAccountsRoute,
  } as any)
const SystemUsersTenantsIndexRoute = SystemUsersTenantsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SystemUsersTenantsRoute,
} as any)
const SystemUsersTenantsTenantIdRoute =
  SystemUsersTenantsTenantIdRouteImport.update({
    id: '/$tenantId',
    path: '/$tenantId',
    getParentRoute: () => SystemUsersTenantsRoute,
  } as any)
const SystemIntegrationsSchedulesScheduleIdRunsRoute =
  SystemIntegrationsSchedulesScheduleIdRunsRouteImport.update({
    id: '/$scheduleId/runs',
    path: '/$scheduleId/runs',
    getParentRoute: () => SystemIntegrationsSchedulesRoute,
  } as any)
const SystemIntegrationsWebhooksWebhookIdDeliveriesRoute =
  SystemIntegrationsWebhooksWebhookIdDeliveriesRouteImport.update({
    id: '/$webhookId/deliveries',
    path: '/$webhookId/deliveries',
    getParentRoute: () => SystemIntegrationsWebhooksRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/500': typeof R500Route
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/offline': typeof OfflineRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/app/applications': typeof AppApplicationsRoute
  '/app/commerce': typeof AppCommerceRoute
  '/app/feedbacks': typeof AppFeedbacksRoute
  '/app/upgrade-center': typeof AppUpgradeCenterRoute
  '/app/users': typeof AppUsersRoute
  '/profile/basic': typeof ProfileBasicRoute
  '/profile/connections': typeof ProfileConnectionsRoute
  '/profile/security': typeof ProfileSecurityRoute
  '/app/content/articles': typeof AppContentArticlesRoute
  '/app/content/categories': typeof AppContentCategoriesRoute
  '/app/content/pages': typeof AppContentPagesRoute
  '/app/support/characters': typeof AppSupportCharactersRoute
  '/app/support/faq': typeof AppSupportFaqRoute
  '/app/support/inbox': typeof AppSupportInboxRoute
  '/app/support/products': typeof AppSupportProductsRoute
  '/app/support/settings': typeof AppSupportSettingsRoute
  '/app/support/sites': typeof AppSupportSitesRoute
  '/auth/callback/$provider': typeof AuthCallbackProviderRoute
  '/system/access/menus': typeof SystemAccessMenusRoute
  '/system/access/permissions': typeof SystemAccessPermissionsRoute
  '/system/access/roles': typeof SystemAccessRolesRouteWithChildren
  '/system/ai/access': typeof SystemAiAccessRoute
  '/system/ai/models': typeof SystemAiModelsRoute
  '/system/ai/playground': typeof SystemAiPlaygroundRoute
  '/system/ai/providers': typeof SystemAiProvidersRoute
  '/system/ai/usage': typeof SystemAiUsageRoute
  '/system/content/articles': typeof SystemContentArticlesRoute
  '/system/content/categories': typeof SystemContentCategoriesRoute
  '/system/integrations/api-clients': typeof SystemIntegrationsApiClientsRouteWithChildren
  '/system/integrations/schedules': typeof SystemIntegrationsSchedulesRouteWithChildren
  '/system/integrations/webhooks': typeof SystemIntegrationsWebhooksRouteWithChildren
  '/system/mobile/releases': typeof SystemMobileReleasesRoute
  '/system/monitoring/health': typeof SystemMonitoringHealthRoute
  '/system/monitoring/sessions': typeof SystemMonitoringSessionsRoute
  '/system/notifications/deliveries': typeof SystemNotificationsDeliveriesRoute
  '/system/notifications/messages': typeof SystemNotificationsMessagesRouteWithChildren
  '/system/notifications/notices': typeof SystemNotificationsNoticesRouteWithChildren
  '/system/notifications/operations': typeof SystemNotificationsOperationsRoute
  '/system/notifications/push-channels': typeof SystemNotificationsPushChannelsRoute
  '/system/notifications/templates': typeof SystemNotificationsTemplatesRoute
  '/system/security/block-rules': typeof SystemSecurityBlockRulesRoute
  '/system/security/events': typeof SystemSecurityEventsRouteWithChildren
  '/system/security/login-logs': typeof SystemSecurityLoginLogsRoute
  '/system/security/operation-logs': typeof SystemSecurityOperationLogsRoute
  '/system/settings/configs': typeof SystemSettingsConfigsRoute
  '/system/settings/dictionaries': typeof SystemSettingsDictionariesRoute
  '/system/settings/login-providers': typeof SystemSettingsLoginProvidersRoute
  '/system/settings/regions': typeof SystemSettingsRegionsRoute
  '/system/settings/share-configs': typeof SystemSettingsShareConfigsRoute
  '/system/storage/files': typeof SystemStorageFilesRouteWithChildren
  '/system/users/accounts': typeof SystemUsersAccountsRouteWithChildren
  '/system/users/departments': typeof SystemUsersDepartmentsRoute
  '/system/users/positions': typeof SystemUsersPositionsRoute
  '/system/users/tenants': typeof SystemUsersTenantsRouteWithChildren
  '/system/access/roles/$roleId': typeof SystemAccessRolesRoleIdRoute
  '/system/integrations/api-clients/$clientId': typeof SystemIntegrationsApiClientsClientIdRoute
  '/system/notifications/messages/$messageId': typeof SystemNotificationsMessagesMessageIdRoute
  '/system/notifications/notices/$noticeId': typeof SystemNotificationsNoticesNoticeIdRoute
  '/system/security/events/$eventId': typeof SystemSecurityEventsEventIdRoute
  '/system/storage/files/$fileId': typeof SystemStorageFilesFileIdRoute
  '/system/users/accounts/$userId': typeof SystemUsersAccountsUserIdRoute
  '/system/users/tenants/$tenantId': typeof SystemUsersTenantsTenantIdRoute
  '/system/access/roles/': typeof SystemAccessRolesIndexRoute
  '/system/integrations/api-clients/': typeof SystemIntegrationsApiClientsIndexRoute
  '/system/integrations/schedules/': typeof SystemIntegrationsSchedulesIndexRoute
  '/system/notifications/messages/': typeof SystemNotificationsMessagesIndexRoute
  '/system/notifications/notices/': typeof SystemNotificationsNoticesIndexRoute
  '/system/security/events/': typeof SystemSecurityEventsIndexRoute
  '/system/storage/files/': typeof SystemStorageFilesIndexRoute
  '/system/users/accounts/': typeof SystemUsersAccountsIndexRoute
  '/system/users/tenants/': typeof SystemUsersTenantsIndexRoute
  '/system/integrations/schedules/$scheduleId/runs': typeof SystemIntegrationsSchedulesScheduleIdRunsRoute
  '/system/integrations/webhooks/$webhookId/deliveries': typeof SystemIntegrationsWebhooksWebhookIdDeliveriesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/500': typeof R500Route
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/offline': typeof OfflineRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/app/applications': typeof AppApplicationsRoute
  '/app/commerce': typeof AppCommerceRoute
  '/app/feedbacks': typeof AppFeedbacksRoute
  '/app/upgrade-center': typeof AppUpgradeCenterRoute
  '/app/users': typeof AppUsersRoute
  '/profile/basic': typeof ProfileBasicRoute
  '/profile/connections': typeof ProfileConnectionsRoute
  '/profile/security': typeof ProfileSecurityRoute
  '/app/content/articles': typeof AppContentArticlesRoute
  '/app/content/categories': typeof AppContentCategoriesRoute
  '/app/content/pages': typeof AppContentPagesRoute
  '/app/support/characters': typeof AppSupportCharactersRoute
  '/app/support/faq': typeof AppSupportFaqRoute
  '/app/support/inbox': typeof AppSupportInboxRoute
  '/app/support/products': typeof AppSupportProductsRoute
  '/app/support/settings': typeof AppSupportSettingsRoute
  '/app/support/sites': typeof AppSupportSitesRoute
  '/auth/callback/$provider': typeof AuthCallbackProviderRoute
  '/system/access/menus': typeof SystemAccessMenusRoute
  '/system/access/permissions': typeof SystemAccessPermissionsRoute
  '/system/ai/access': typeof SystemAiAccessRoute
  '/system/ai/models': typeof SystemAiModelsRoute
  '/system/ai/playground': typeof SystemAiPlaygroundRoute
  '/system/ai/providers': typeof SystemAiProvidersRoute
  '/system/ai/usage': typeof SystemAiUsageRoute
  '/system/content/articles': typeof SystemContentArticlesRoute
  '/system/content/categories': typeof SystemContentCategoriesRoute
  '/system/integrations/webhooks': typeof SystemIntegrationsWebhooksRouteWithChildren
  '/system/mobile/releases': typeof SystemMobileReleasesRoute
  '/system/monitoring/health': typeof SystemMonitoringHealthRoute
  '/system/monitoring/sessions': typeof SystemMonitoringSessionsRoute
  '/system/notifications/deliveries': typeof SystemNotificationsDeliveriesRoute
  '/system/notifications/operations': typeof SystemNotificationsOperationsRoute
  '/system/notifications/push-channels': typeof SystemNotificationsPushChannelsRoute
  '/system/notifications/templates': typeof SystemNotificationsTemplatesRoute
  '/system/security/block-rules': typeof SystemSecurityBlockRulesRoute
  '/system/security/login-logs': typeof SystemSecurityLoginLogsRoute
  '/system/security/operation-logs': typeof SystemSecurityOperationLogsRoute
  '/system/settings/configs': typeof SystemSettingsConfigsRoute
  '/system/settings/dictionaries': typeof SystemSettingsDictionariesRoute
  '/system/settings/login-providers': typeof SystemSettingsLoginProvidersRoute
  '/system/settings/regions': typeof SystemSettingsRegionsRoute
  '/system/settings/share-configs': typeof SystemSettingsShareConfigsRoute
  '/system/users/departments': typeof SystemUsersDepartmentsRoute
  '/system/users/positions': typeof SystemUsersPositionsRoute
  '/system/access/roles/$roleId': typeof SystemAccessRolesRoleIdRoute
  '/system/integrations/api-clients/$clientId': typeof SystemIntegrationsApiClientsClientIdRoute
  '/system/notifications/messages/$messageId': typeof SystemNotificationsMessagesMessageIdRoute
  '/system/notifications/notices/$noticeId': typeof SystemNotificationsNoticesNoticeIdRoute
  '/system/security/events/$eventId': typeof SystemSecurityEventsEventIdRoute
  '/system/storage/files/$fileId': typeof SystemStorageFilesFileIdRoute
  '/system/users/accounts/$userId': typeof SystemUsersAccountsUserIdRoute
  '/system/users/tenants/$tenantId': typeof SystemUsersTenantsTenantIdRoute
  '/system/access/roles': typeof SystemAccessRolesIndexRoute
  '/system/integrations/api-clients': typeof SystemIntegrationsApiClientsIndexRoute
  '/system/integrations/schedules': typeof SystemIntegrationsSchedulesIndexRoute
  '/system/notifications/messages': typeof SystemNotificationsMessagesIndexRoute
  '/system/notifications/notices': typeof SystemNotificationsNoticesIndexRoute
  '/system/security/events': typeof SystemSecurityEventsIndexRoute
  '/system/storage/files': typeof SystemStorageFilesIndexRoute
  '/system/users/accounts': typeof SystemUsersAccountsIndexRoute
  '/system/users/tenants': typeof SystemUsersTenantsIndexRoute
  '/system/integrations/schedules/$scheduleId/runs': typeof SystemIntegrationsSchedulesScheduleIdRunsRoute
  '/system/integrations/webhooks/$webhookId/deliveries': typeof SystemIntegrationsWebhooksWebhookIdDeliveriesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/500': typeof R500Route
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/offline': typeof OfflineRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/app/applications': typeof AppApplicationsRoute
  '/app/commerce': typeof AppCommerceRoute
  '/app/feedbacks': typeof AppFeedbacksRoute
  '/app/upgrade-center': typeof AppUpgradeCenterRoute
  '/app/users': typeof AppUsersRoute
  '/profile/basic': typeof ProfileBasicRoute
  '/profile/connections': typeof ProfileConnectionsRoute
  '/profile/security': typeof ProfileSecurityRoute
  '/app/content/articles': typeof AppContentArticlesRoute
  '/app/content/categories': typeof AppContentCategoriesRoute
  '/app/content/pages': typeof AppContentPagesRoute
  '/app/support/characters': typeof AppSupportCharactersRoute
  '/app/support/faq': typeof AppSupportFaqRoute
  '/app/support/inbox': typeof AppSupportInboxRoute
  '/app/support/products': typeof AppSupportProductsRoute
  '/app/support/settings': typeof AppSupportSettingsRoute
  '/app/support/sites': typeof AppSupportSitesRoute
  '/auth/callback/$provider': typeof AuthCallbackProviderRoute
  '/system/access/menus': typeof SystemAccessMenusRoute
  '/system/access/permissions': typeof SystemAccessPermissionsRoute
  '/system/access/roles': typeof SystemAccessRolesRouteWithChildren
  '/system/ai/access': typeof SystemAiAccessRoute
  '/system/ai/models': typeof SystemAiModelsRoute
  '/system/ai/playground': typeof SystemAiPlaygroundRoute
  '/system/ai/providers': typeof SystemAiProvidersRoute
  '/system/ai/usage': typeof SystemAiUsageRoute
  '/system/content/articles': typeof SystemContentArticlesRoute
  '/system/content/categories': typeof SystemContentCategoriesRoute
  '/system/integrations/api-clients': typeof SystemIntegrationsApiClientsRouteWithChildren
  '/system/integrations/schedules': typeof SystemIntegrationsSchedulesRouteWithChildren
  '/system/integrations/webhooks': typeof SystemIntegrationsWebhooksRouteWithChildren
  '/system/mobile/releases': typeof SystemMobileReleasesRoute
  '/system/monitoring/health': typeof SystemMonitoringHealthRoute
  '/system/monitoring/sessions': typeof SystemMonitoringSessionsRoute
  '/system/notifications/deliveries': typeof SystemNotificationsDeliveriesRoute
  '/system/notifications/messages': typeof SystemNotificationsMessagesRouteWithChildren
  '/system/notifications/notices': typeof SystemNotificationsNoticesRouteWithChildren
  '/system/notifications/operations': typeof SystemNotificationsOperationsRoute
  '/system/notifications/push-channels': typeof SystemNotificationsPushChannelsRoute
  '/system/notifications/templates': typeof SystemNotificationsTemplatesRoute
  '/system/security/block-rules': typeof SystemSecurityBlockRulesRoute
  '/system/security/events': typeof SystemSecurityEventsRouteWithChildren
  '/system/security/login-logs': typeof SystemSecurityLoginLogsRoute
  '/system/security/operation-logs': typeof SystemSecurityOperationLogsRoute
  '/system/settings/configs': typeof SystemSettingsConfigsRoute
  '/system/settings/dictionaries': typeof SystemSettingsDictionariesRoute
  '/system/settings/login-providers': typeof SystemSettingsLoginProvidersRoute
  '/system/settings/regions': typeof SystemSettingsRegionsRoute
  '/system/settings/share-configs': typeof SystemSettingsShareConfigsRoute
  '/system/storage/files': typeof SystemStorageFilesRouteWithChildren
  '/system/users/accounts': typeof SystemUsersAccountsRouteWithChildren
  '/system/users/departments': typeof SystemUsersDepartmentsRoute
  '/system/users/positions': typeof SystemUsersPositionsRoute
  '/system/users/tenants': typeof SystemUsersTenantsRouteWithChildren
  '/system/access/roles/$roleId': typeof SystemAccessRolesRoleIdRoute
  '/system/integrations/api-clients/$clientId': typeof SystemIntegrationsApiClientsClientIdRoute
  '/system/notifications/messages/$messageId': typeof SystemNotificationsMessagesMessageIdRoute
  '/system/notifications/notices/$noticeId': typeof SystemNotificationsNoticesNoticeIdRoute
  '/system/security/events/$eventId': typeof SystemSecurityEventsEventIdRoute
  '/system/storage/files/$fileId': typeof SystemStorageFilesFileIdRoute
  '/system/users/accounts/$userId': typeof SystemUsersAccountsUserIdRoute
  '/system/users/tenants/$tenantId': typeof SystemUsersTenantsTenantIdRoute
  '/system/access/roles/': typeof SystemAccessRolesIndexRoute
  '/system/integrations/api-clients/': typeof SystemIntegrationsApiClientsIndexRoute
  '/system/integrations/schedules/': typeof SystemIntegrationsSchedulesIndexRoute
  '/system/notifications/messages/': typeof SystemNotificationsMessagesIndexRoute
  '/system/notifications/notices/': typeof SystemNotificationsNoticesIndexRoute
  '/system/security/events/': typeof SystemSecurityEventsIndexRoute
  '/system/storage/files/': typeof SystemStorageFilesIndexRoute
  '/system/users/accounts/': typeof SystemUsersAccountsIndexRoute
  '/system/users/tenants/': typeof SystemUsersTenantsIndexRoute
  '/system/integrations/schedules/$scheduleId/runs': typeof SystemIntegrationsSchedulesScheduleIdRunsRoute
  '/system/integrations/webhooks/$webhookId/deliveries': typeof SystemIntegrationsWebhooksWebhookIdDeliveriesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/403'
    | '/404'
    | '/500'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/offline'
    | '/register'
    | '/reset-password'
    | '/app/applications'
    | '/app/commerce'
    | '/app/feedbacks'
    | '/app/upgrade-center'
    | '/app/users'
    | '/profile/basic'
    | '/profile/connections'
    | '/profile/security'
    | '/app/content/articles'
    | '/app/content/categories'
    | '/app/content/pages'
    | '/app/support/characters'
    | '/app/support/faq'
    | '/app/support/inbox'
    | '/app/support/products'
    | '/app/support/settings'
    | '/app/support/sites'
    | '/auth/callback/$provider'
    | '/system/access/menus'
    | '/system/access/permissions'
    | '/system/access/roles'
    | '/system/ai/access'
    | '/system/ai/models'
    | '/system/ai/playground'
    | '/system/ai/providers'
    | '/system/ai/usage'
    | '/system/content/articles'
    | '/system/content/categories'
    | '/system/integrations/api-clients'
    | '/system/integrations/schedules'
    | '/system/integrations/webhooks'
    | '/system/mobile/releases'
    | '/system/monitoring/health'
    | '/system/monitoring/sessions'
    | '/system/notifications/deliveries'
    | '/system/notifications/messages'
    | '/system/notifications/notices'
    | '/system/notifications/operations'
    | '/system/notifications/push-channels'
    | '/system/notifications/templates'
    | '/system/security/block-rules'
    | '/system/security/events'
    | '/system/security/login-logs'
    | '/system/security/operation-logs'
    | '/system/settings/configs'
    | '/system/settings/dictionaries'
    | '/system/settings/login-providers'
    | '/system/settings/regions'
    | '/system/settings/share-configs'
    | '/system/storage/files'
    | '/system/users/accounts'
    | '/system/users/departments'
    | '/system/users/positions'
    | '/system/users/tenants'
    | '/system/access/roles/$roleId'
    | '/system/integrations/api-clients/$clientId'
    | '/system/notifications/messages/$messageId'
    | '/system/notifications/notices/$noticeId'
    | '/system/security/events/$eventId'
    | '/system/storage/files/$fileId'
    | '/system/users/accounts/$userId'
    | '/system/users/tenants/$tenantId'
    | '/system/access/roles/'
    | '/system/integrations/api-clients/'
    | '/system/integrations/schedules/'
    | '/system/notifications/messages/'
    | '/system/notifications/notices/'
    | '/system/security/events/'
    | '/system/storage/files/'
    | '/system/users/accounts/'
    | '/system/users/tenants/'
    | '/system/integrations/schedules/$scheduleId/runs'
    | '/system/integrations/webhooks/$webhookId/deliveries'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/403'
    | '/404'
    | '/500'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/offline'
    | '/register'
    | '/reset-password'
    | '/app/applications'
    | '/app/commerce'
    | '/app/feedbacks'
    | '/app/upgrade-center'
    | '/app/users'
    | '/profile/basic'
    | '/profile/connections'
    | '/profile/security'
    | '/app/content/articles'
    | '/app/content/categories'
    | '/app/content/pages'
    | '/app/support/characters'
    | '/app/support/faq'
    | '/app/support/inbox'
    | '/app/support/products'
    | '/app/support/settings'
    | '/app/support/sites'
    | '/auth/callback/$provider'
    | '/system/access/menus'
    | '/system/access/permissions'
    | '/system/ai/access'
    | '/system/ai/models'
    | '/system/ai/playground'
    | '/system/ai/providers'
    | '/system/ai/usage'
    | '/system/content/articles'
    | '/system/content/categories'
    | '/system/integrations/webhooks'
    | '/system/mobile/releases'
    | '/system/monitoring/health'
    | '/system/monitoring/sessions'
    | '/system/notifications/deliveries'
    | '/system/notifications/operations'
    | '/system/notifications/push-channels'
    | '/system/notifications/templates'
    | '/system/security/block-rules'
    | '/system/security/login-logs'
    | '/system/security/operation-logs'
    | '/system/settings/configs'
    | '/system/settings/dictionaries'
    | '/system/settings/login-providers'
    | '/system/settings/regions'
    | '/system/settings/share-configs'
    | '/system/users/departments'
    | '/system/users/positions'
    | '/system/access/roles/$roleId'
    | '/system/integrations/api-clients/$clientId'
    | '/system/notifications/messages/$messageId'
    | '/system/notifications/notices/$noticeId'
    | '/system/security/events/$eventId'
    | '/system/storage/files/$fileId'
    | '/system/users/accounts/$userId'
    | '/system/users/tenants/$tenantId'
    | '/system/access/roles'
    | '/system/integrations/api-clients'
    | '/system/integrations/schedules'
    | '/system/notifications/messages'
    | '/system/notifications/notices'
    | '/system/security/events'
    | '/system/storage/files'
    | '/system/users/accounts'
    | '/system/users/tenants'
    | '/system/integrations/schedules/$scheduleId/runs'
    | '/system/integrations/webhooks/$webhookId/deliveries'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/403'
    | '/404'
    | '/500'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/offline'
    | '/register'
    | '/reset-password'
    | '/app/applications'
    | '/app/commerce'
    | '/app/feedbacks'
    | '/app/upgrade-center'
    | '/app/users'
    | '/profile/basic'
    | '/profile/connections'
    | '/profile/security'
    | '/app/content/articles'
    | '/app/content/categories'
    | '/app/content/pages'
    | '/app/support/characters'
    | '/app/support/faq'
    | '/app/support/inbox'
    | '/app/support/products'
    | '/app/support/settings'
    | '/app/support/sites'
    | '/auth/callback/$provider'
    | '/system/access/menus'
    | '/system/access/permissions'
    | '/system/access/roles'
    | '/system/ai/access'
    | '/system/ai/models'
    | '/system/ai/playground'
    | '/system/ai/providers'
    | '/system/ai/usage'
    | '/system/content/articles'
    | '/system/content/categories'
    | '/system/integrations/api-clients'
    | '/system/integrations/schedules'
    | '/system/integrations/webhooks'
    | '/system/mobile/releases'
    | '/system/monitoring/health'
    | '/system/monitoring/sessions'
    | '/system/notifications/deliveries'
    | '/system/notifications/messages'
    | '/system/notifications/notices'
    | '/system/notifications/operations'
    | '/system/notifications/push-channels'
    | '/system/notifications/templates'
    | '/system/security/block-rules'
    | '/system/security/events'
    | '/system/security/login-logs'
    | '/system/security/operation-logs'
    | '/system/settings/configs'
    | '/system/settings/dictionaries'
    | '/system/settings/login-providers'
    | '/system/settings/regions'
    | '/system/settings/share-configs'
    | '/system/storage/files'
    | '/system/users/accounts'
    | '/system/users/departments'
    | '/system/users/positions'
    | '/system/users/tenants'
    | '/system/access/roles/$roleId'
    | '/system/integrations/api-clients/$clientId'
    | '/system/notifications/messages/$messageId'
    | '/system/notifications/notices/$noticeId'
    | '/system/security/events/$eventId'
    | '/system/storage/files/$fileId'
    | '/system/users/accounts/$userId'
    | '/system/users/tenants/$tenantId'
    | '/system/access/roles/'
    | '/system/integrations/api-clients/'
    | '/system/integrations/schedules/'
    | '/system/notifications/messages/'
    | '/system/notifications/notices/'
    | '/system/security/events/'
    | '/system/storage/files/'
    | '/system/users/accounts/'
    | '/system/users/tenants/'
    | '/system/integrations/schedules/$scheduleId/runs'
    | '/system/integrations/webhooks/$webhookId/deliveries'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  R403Route: typeof R403Route
  R404Route: typeof R404Route
  R500Route: typeof R500Route
  DashboardRoute: typeof DashboardRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  OfflineRoute: typeof OfflineRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  AppApplicationsRoute: typeof AppApplicationsRoute
  AppCommerceRoute: typeof AppCommerceRoute
  AppFeedbacksRoute: typeof AppFeedbacksRoute
  AppUpgradeCenterRoute: typeof AppUpgradeCenterRoute
  AppUsersRoute: typeof AppUsersRoute
  ProfileBasicRoute: typeof ProfileBasicRoute
  ProfileConnectionsRoute: typeof ProfileConnectionsRoute
  ProfileSecurityRoute: typeof ProfileSecurityRoute
  AppContentArticlesRoute: typeof AppContentArticlesRoute
  AppContentCategoriesRoute: typeof AppContentCategoriesRoute
  AppContentPagesRoute: typeof AppContentPagesRoute
  AppSupportCharactersRoute: typeof AppSupportCharactersRoute
  AppSupportFaqRoute: typeof AppSupportFaqRoute
  AppSupportInboxRoute: typeof AppSupportInboxRoute
  AppSupportProductsRoute: typeof AppSupportProductsRoute
  AppSupportSettingsRoute: typeof AppSupportSettingsRoute
  AppSupportSitesRoute: typeof AppSupportSitesRoute
  AuthCallbackProviderRoute: typeof AuthCallbackProviderRoute
  SystemAccessMenusRoute: typeof SystemAccessMenusRoute
  SystemAccessPermissionsRoute: typeof SystemAccessPermissionsRoute
  SystemAccessRolesRoute: typeof SystemAccessRolesRouteWithChildren
  SystemAiAccessRoute: typeof SystemAiAccessRoute
  SystemAiModelsRoute: typeof SystemAiModelsRoute
  SystemAiPlaygroundRoute: typeof SystemAiPlaygroundRoute
  SystemAiProvidersRoute: typeof SystemAiProvidersRoute
  SystemAiUsageRoute: typeof SystemAiUsageRoute
  SystemContentArticlesRoute: typeof SystemContentArticlesRoute
  SystemContentCategoriesRoute: typeof SystemContentCategoriesRoute
  SystemIntegrationsApiClientsRoute: typeof SystemIntegrationsApiClientsRouteWithChildren
  SystemIntegrationsSchedulesRoute: typeof SystemIntegrationsSchedulesRouteWithChildren
  SystemIntegrationsWebhooksRoute: typeof SystemIntegrationsWebhooksRouteWithChildren
  SystemMobileReleasesRoute: typeof SystemMobileReleasesRoute
  SystemMonitoringHealthRoute: typeof SystemMonitoringHealthRoute
  SystemMonitoringSessionsRoute: typeof SystemMonitoringSessionsRoute
  SystemNotificationsDeliveriesRoute: typeof SystemNotificationsDeliveriesRoute
  SystemNotificationsMessagesRoute: typeof SystemNotificationsMessagesRouteWithChildren
  SystemNotificationsNoticesRoute: typeof SystemNotificationsNoticesRouteWithChildren
  SystemNotificationsOperationsRoute: typeof SystemNotificationsOperationsRoute
  SystemNotificationsPushChannelsRoute: typeof SystemNotificationsPushChannelsRoute
  SystemNotificationsTemplatesRoute: typeof SystemNotificationsTemplatesRoute
  SystemSecurityBlockRulesRoute: typeof SystemSecurityBlockRulesRoute
  SystemSecurityEventsRoute: typeof SystemSecurityEventsRouteWithChildren
  SystemSecurityLoginLogsRoute: typeof SystemSecurityLoginLogsRoute
  SystemSecurityOperationLogsRoute: typeof SystemSecurityOperationLogsRoute
  SystemSettingsConfigsRoute: typeof SystemSettingsConfigsRoute
  SystemSettingsDictionariesRoute: typeof SystemSettingsDictionariesRoute
  SystemSettingsLoginProvidersRoute: typeof SystemSettingsLoginProvidersRoute
  SystemSettingsRegionsRoute: typeof SystemSettingsRegionsRoute
  SystemSettingsShareConfigsRoute: typeof SystemSettingsShareConfigsRoute
  SystemStorageFilesRoute: typeof SystemStorageFilesRouteWithChildren
  SystemUsersAccountsRoute: typeof SystemUsersAccountsRouteWithChildren
  SystemUsersDepartmentsRoute: typeof SystemUsersDepartmentsRoute
  SystemUsersPositionsRoute: typeof SystemUsersPositionsRoute
  SystemUsersTenantsRoute: typeof SystemUsersTenantsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/500': {
      id: '/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof R500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offline': {
      id: '/offline'
      path: '/offline'
      fullPath: '/offline'
      preLoaderRoute: typeof OfflineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/applications': {
      id: '/app/applications'
      path: '/app/applications'
      fullPath: '/app/applications'
      preLoaderRoute: typeof AppApplicationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/commerce': {
      id: '/app/commerce'
      path: '/app/commerce'
      fullPath: '/app/commerce'
      preLoaderRoute: typeof AppCommerceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/feedbacks': {
      id: '/app/feedbacks'
      path: '/app/feedbacks'
      fullPath: '/app/feedbacks'
      preLoaderRoute: typeof AppFeedbacksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/upgrade-center': {
      id: '/app/upgrade-center'
      path: '/app/upgrade-center'
      fullPath: '/app/upgrade-center'
      preLoaderRoute: typeof AppUpgradeCenterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/users': {
      id: '/app/users'
      path: '/app/users'
      fullPath: '/app/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/basic': {
      id: '/profile/basic'
      path: '/profile/basic'
      fullPath: '/profile/basic'
      preLoaderRoute: typeof ProfileBasicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/connections': {
      id: '/profile/connections'
      path: '/profile/connections'
      fullPath: '/profile/connections'
      preLoaderRoute: typeof ProfileConnectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/security': {
      id: '/profile/security'
      path: '/profile/security'
      fullPath: '/profile/security'
      preLoaderRoute: typeof ProfileSecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/content/articles': {
      id: '/app/content/articles'
      path: '/app/content/articles'
      fullPath: '/app/content/articles'
      preLoaderRoute: typeof AppContentArticlesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/content/categories': {
      id: '/app/content/categories'
      path: '/app/content/categories'
      fullPath: '/app/content/categories'
      preLoaderRoute: typeof AppContentCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/content/pages': {
      id: '/app/content/pages'
      path: '/app/content/pages'
      fullPath: '/app/content/pages'
      preLoaderRoute: typeof AppContentPagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/support/characters': {
      id: '/app/support/characters'
      path: '/app/support/characters'
      fullPath: '/app/support/characters'
      preLoaderRoute: typeof AppSupportCharactersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/support/faq': {
      id: '/app/support/faq'
      path: '/app/support/faq'
      fullPath: '/app/support/faq'
      preLoaderRoute: typeof AppSupportFaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/support/inbox': {
      id: '/app/support/inbox'
      path: '/app/support/inbox'
      fullPath: '/app/support/inbox'
      preLoaderRoute: typeof AppSupportInboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/support/products': {
      id: '/app/support/products'
      path: '/app/support/products'
      fullPath: '/app/support/products'
      preLoaderRoute: typeof AppSupportProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/support/settings': {
      id: '/app/support/settings'
      path: '/app/support/settings'
      fullPath: '/app/support/settings'
      preLoaderRoute: typeof AppSupportSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/support/sites': {
      id: '/app/support/sites'
      path: '/app/support/sites'
      fullPath: '/app/support/sites'
      preLoaderRoute: typeof AppSupportSitesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback/$provider': {
      id: '/auth/callback/$provider'
      path: '/auth/callback/$provider'
      fullPath: '/auth/callback/$provider'
      preLoaderRoute: typeof AuthCallbackProviderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/access/menus': {
      id: '/system/access/menus'
      path: '/system/access/menus'
      fullPath: '/system/access/menus'
      preLoaderRoute: typeof SystemAccessMenusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/access/permissions': {
      id: '/system/access/permissions'
      path: '/system/access/permissions'
      fullPath: '/system/access/permissions'
      preLoaderRoute: typeof SystemAccessPermissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/access/roles': {
      id: '/system/access/roles'
      path: '/system/access/roles'
      fullPath: '/system/access/roles'
      preLoaderRoute: typeof SystemAccessRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/ai/access': {
      id: '/system/ai/access'
      path: '/system/ai/access'
      fullPath: '/system/ai/access'
      preLoaderRoute: typeof SystemAiAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/ai/models': {
      id: '/system/ai/models'
      path: '/system/ai/models'
      fullPath: '/system/ai/models'
      preLoaderRoute: typeof SystemAiModelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/ai/playground': {
      id: '/system/ai/playground'
      path: '/system/ai/playground'
      fullPath: '/system/ai/playground'
      preLoaderRoute: typeof SystemAiPlaygroundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/ai/providers': {
      id: '/system/ai/providers'
      path: '/system/ai/providers'
      fullPath: '/system/ai/providers'
      preLoaderRoute: typeof SystemAiProvidersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/ai/usage': {
      id: '/system/ai/usage'
      path: '/system/ai/usage'
      fullPath: '/system/ai/usage'
      preLoaderRoute: typeof SystemAiUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/content/articles': {
      id: '/system/content/articles'
      path: '/system/content/articles'
      fullPath: '/system/content/articles'
      preLoaderRoute: typeof SystemContentArticlesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/content/categories': {
      id: '/system/content/categories'
      path: '/system/content/categories'
      fullPath: '/system/content/categories'
      preLoaderRoute: typeof SystemContentCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/integrations/api-clients': {
      id: '/system/integrations/api-clients'
      path: '/system/integrations/api-clients'
      fullPath: '/system/integrations/api-clients'
      preLoaderRoute: typeof SystemIntegrationsApiClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/integrations/schedules': {
      id: '/system/integrations/schedules'
      path: '/system/integrations/schedules'
      fullPath: '/system/integrations/schedules'
      preLoaderRoute: typeof SystemIntegrationsSchedulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/integrations/webhooks': {
      id: '/system/integrations/webhooks'
      path: '/system/integrations/webhooks'
      fullPath: '/system/integrations/webhooks'
      preLoaderRoute: typeof SystemIntegrationsWebhooksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/mobile/releases': {
      id: '/system/mobile/releases'
      path: '/system/mobile/releases'
      fullPath: '/system/mobile/releases'
      preLoaderRoute: typeof SystemMobileReleasesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/monitoring/health': {
      id: '/system/monitoring/health'
      path: '/system/monitoring/health'
      fullPath: '/system/monitoring/health'
      preLoaderRoute: typeof SystemMonitoringHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/monitoring/sessions': {
      id: '/system/monitoring/sessions'
      path: '/system/monitoring/sessions'
      fullPath: '/system/monitoring/sessions'
      preLoaderRoute: typeof SystemMonitoringSessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/notifications/deliveries': {
      id: '/system/notifications/deliveries'
      path: '/system/notifications/deliveries'
      fullPath: '/system/notifications/deliveries'
      preLoaderRoute: typeof SystemNotificationsDeliveriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/notifications/messages': {
      id: '/system/notifications/messages'
      path: '/system/notifications/messages'
      fullPath: '/system/notifications/messages'
      preLoaderRoute: typeof SystemNotificationsMessagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/notifications/notices': {
      id: '/system/notifications/notices'
      path: '/system/notifications/notices'
      fullPath: '/system/notifications/notices'
      preLoaderRoute: typeof SystemNotificationsNoticesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/notifications/operations': {
      id: '/system/notifications/operations'
      path: '/system/notifications/operations'
      fullPath: '/system/notifications/operations'
      preLoaderRoute: typeof SystemNotificationsOperationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/notifications/push-channels': {
      id: '/system/notifications/push-channels'
      path: '/system/notifications/push-channels'
      fullPath: '/system/notifications/push-channels'
      preLoaderRoute: typeof SystemNotificationsPushChannelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/notifications/templates': {
      id: '/system/notifications/templates'
      path: '/system/notifications/templates'
      fullPath: '/system/notifications/templates'
      preLoaderRoute: typeof SystemNotificationsTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/security/block-rules': {
      id: '/system/security/block-rules'
      path: '/system/security/block-rules'
      fullPath: '/system/security/block-rules'
      preLoaderRoute: typeof SystemSecurityBlockRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/security/events': {
      id: '/system/security/events'
      path: '/system/security/events'
      fullPath: '/system/security/events'
      preLoaderRoute: typeof SystemSecurityEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/security/login-logs': {
      id: '/system/security/login-logs'
      path: '/system/security/login-logs'
      fullPath: '/system/security/login-logs'
      preLoaderRoute: typeof SystemSecurityLoginLogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/security/operation-logs': {
      id: '/system/security/operation-logs'
      path: '/system/security/operation-logs'
      fullPath: '/system/security/operation-logs'
      preLoaderRoute: typeof SystemSecurityOperationLogsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/settings/configs': {
      id: '/system/settings/configs'
      path: '/system/settings/configs'
      fullPath: '/system/settings/configs'
      preLoaderRoute: typeof SystemSettingsConfigsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/settings/dictionaries': {
      id: '/system/settings/dictionaries'
      path: '/system/settings/dictionaries'
      fullPath: '/system/settings/dictionaries'
      preLoaderRoute: typeof SystemSettingsDictionariesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/settings/login-providers': {
      id: '/system/settings/login-providers'
      path: '/system/settings/login-providers'
      fullPath: '/system/settings/login-providers'
      preLoaderRoute: typeof SystemSettingsLoginProvidersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/settings/regions': {
      id: '/system/settings/regions'
      path: '/system/settings/regions'
      fullPath: '/system/settings/regions'
      preLoaderRoute: typeof SystemSettingsRegionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/settings/share-configs': {
      id: '/system/settings/share-configs'
      path: '/system/settings/share-configs'
      fullPath: '/system/settings/share-configs'
      preLoaderRoute: typeof SystemSettingsShareConfigsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/storage/files': {
      id: '/system/storage/files'
      path: '/system/storage/files'
      fullPath: '/system/storage/files'
      preLoaderRoute: typeof SystemStorageFilesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/users/accounts': {
      id: '/system/users/accounts'
      path: '/system/users/accounts'
      fullPath: '/system/users/accounts'
      preLoaderRoute: typeof SystemUsersAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/users/departments': {
      id: '/system/users/departments'
      path: '/system/users/departments'
      fullPath: '/system/users/departments'
      preLoaderRoute: typeof SystemUsersDepartmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/users/positions': {
      id: '/system/users/positions'
      path: '/system/users/positions'
      fullPath: '/system/users/positions'
      preLoaderRoute: typeof SystemUsersPositionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/users/tenants': {
      id: '/system/users/tenants'
      path: '/system/users/tenants'
      fullPath: '/system/users/tenants'
      preLoaderRoute: typeof SystemUsersTenantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/access/roles/': {
      id: '/system/access/roles/'
      path: '/'
      fullPath: '/system/access/roles/'
      preLoaderRoute: typeof SystemAccessRolesIndexRouteImport
      parentRoute: typeof SystemAccessRolesRoute
    }
    '/system/access/roles/$roleId': {
      id: '/system/access/roles/$roleId'
      path: '/$roleId'
      fullPath: '/system/access/roles/$roleId'
      preLoaderRoute: typeof SystemAccessRolesRoleIdRouteImport
      parentRoute: typeof SystemAccessRolesRoute
    }
    '/system/integrations/api-clients/': {
      id: '/system/integrations/api-clients/'
      path: '/'
      fullPath: '/system/integrations/api-clients/'
      preLoaderRoute: typeof SystemIntegrationsApiClientsIndexRouteImport
      parentRoute: typeof SystemIntegrationsApiClientsRoute
    }
    '/system/integrations/api-clients/$clientId': {
      id: '/system/integrations/api-clients/$clientId'
      path: '/$clientId'
      fullPath: '/system/integrations/api-clients/$clientId'
      preLoaderRoute: typeof SystemIntegrationsApiClientsClientIdRouteImport
      parentRoute: typeof SystemIntegrationsApiClientsRoute
    }
    '/system/integrations/schedules/': {
      id: '/system/integrations/schedules/'
      path: '/'
      fullPath: '/system/integrations/schedules/'
      preLoaderRoute: typeof SystemIntegrationsSchedulesIndexRouteImport
      parentRoute: typeof SystemIntegrationsSchedulesRoute
    }
    '/system/notifications/messages/': {
      id: '/system/notifications/messages/'
      path: '/'
      fullPath: '/system/notifications/messages/'
      preLoaderRoute: typeof SystemNotificationsMessagesIndexRouteImport
      parentRoute: typeof SystemNotificationsMessagesRoute
    }
    '/system/notifications/messages/$messageId': {
      id: '/system/notifications/messages/$messageId'
      path: '/$messageId'
      fullPath: '/system/notifications/messages/$messageId'
      preLoaderRoute: typeof SystemNotificationsMessagesMessageIdRouteImport
      parentRoute: typeof SystemNotificationsMessagesRoute
    }
    '/system/notifications/notices/': {
      id: '/system/notifications/notices/'
      path: '/'
      fullPath: '/system/notifications/notices/'
      preLoaderRoute: typeof SystemNotificationsNoticesIndexRouteImport
      parentRoute: typeof SystemNotificationsNoticesRoute
    }
    '/system/notifications/notices/$noticeId': {
      id: '/system/notifications/notices/$noticeId'
      path: '/$noticeId'
      fullPath: '/system/notifications/notices/$noticeId'
      preLoaderRoute: typeof SystemNotificationsNoticesNoticeIdRouteImport
      parentRoute: typeof SystemNotificationsNoticesRoute
    }
    '/system/security/events/': {
      id: '/system/security/events/'
      path: '/'
      fullPath: '/system/security/events/'
      preLoaderRoute: typeof SystemSecurityEventsIndexRouteImport
      parentRoute: typeof SystemSecurityEventsRoute
    }
    '/system/security/events/$eventId': {
      id: '/system/security/events/$eventId'
      path: '/$eventId'
      fullPath: '/system/security/events/$eventId'
      preLoaderRoute: typeof SystemSecurityEventsEventIdRouteImport
      parentRoute: typeof SystemSecurityEventsRoute
    }
    '/system/storage/files/': {
      id: '/system/storage/files/'
      path: '/'
      fullPath: '/system/storage/files/'
      preLoaderRoute: typeof SystemStorageFilesIndexRouteImport
      parentRoute: typeof SystemStorageFilesRoute
    }
    '/system/storage/files/$fileId': {
      id: '/system/storage/files/$fileId'
      path: '/$fileId'
      fullPath: '/system/storage/files/$fileId'
      preLoaderRoute: typeof SystemStorageFilesFileIdRouteImport
      parentRoute: typeof SystemStorageFilesRoute
    }
    '/system/users/accounts/': {
      id: '/system/users/accounts/'
      path: '/'
      fullPath: '/system/users/accounts/'
      preLoaderRoute: typeof SystemUsersAccountsIndexRouteImport
      parentRoute: typeof SystemUsersAccountsRoute
    }
    '/system/users/accounts/$userId': {
      id: '/system/users/accounts/$userId'
      path: '/$userId'
      fullPath: '/system/users/accounts/$userId'
      preLoaderRoute: typeof SystemUsersAccountsUserIdRouteImport
      parentRoute: typeof SystemUsersAccountsRoute
    }
    '/system/users/tenants/': {
      id: '/system/users/tenants/'
      path: '/'
      fullPath: '/system/users/tenants/'
      preLoaderRoute: typeof SystemUsersTenantsIndexRouteImport
      parentRoute: typeof SystemUsersTenantsRoute
    }
    '/system/users/tenants/$tenantId': {
      id: '/system/users/tenants/$tenantId'
      path: '/$tenantId'
      fullPath: '/system/users/tenants/$tenantId'
      preLoaderRoute: typeof SystemUsersTenantsTenantIdRouteImport
      parentRoute: typeof SystemUsersTenantsRoute
    }
    '/system/integrations/schedules/$scheduleId/runs': {
      id: '/system/integrations/schedules/$scheduleId/runs'
      path: '/$scheduleId/runs'
      fullPath: '/system/integrations/schedules/$scheduleId/runs'
      preLoaderRoute: typeof SystemIntegrationsSchedulesScheduleIdRunsRouteImport
      parentRoute: typeof SystemIntegrationsSchedulesRoute
    }
    '/system/integrations/webhooks/$webhookId/deliveries': {
      id: '/system/integrations/webhooks/$webhookId/deliveries'
      path: '/$webhookId/deliveries'
      fullPath: '/system/integrations/webhooks/$webhookId/deliveries'
      preLoaderRoute: typeof SystemIntegrationsWebhooksWebhookIdDeliveriesRouteImport
      parentRoute: typeof SystemIntegrationsWebhooksRoute
    }
  }
}

interface SystemAccessRolesRouteChildren {
  SystemAccessRolesRoleIdRoute: typeof SystemAccessRolesRoleIdRoute
  SystemAccessRolesIndexRoute: typeof SystemAccessRolesIndexRoute
}

const SystemAccessRolesRouteChildren: SystemAccessRolesRouteChildren = {
  SystemAccessRolesRoleIdRoute: SystemAccessRolesRoleIdRoute,
  SystemAccessRolesIndexRoute: SystemAccessRolesIndexRoute,
}

const SystemAccessRolesRouteWithChildren =
  SystemAccessRolesRoute._addFileChildren(SystemAccessRolesRouteChildren)

interface SystemIntegrationsApiClientsRouteChildren {
  SystemIntegrationsApiClientsClientIdRoute: typeof SystemIntegrationsApiClientsClientIdRoute
  SystemIntegrationsApiClientsIndexRoute: typeof SystemIntegrationsApiClientsIndexRoute
}

const SystemIntegrationsApiClientsRouteChildren: SystemIntegrationsApiClientsRouteChildren =
  {
    SystemIntegrationsApiClientsClientIdRoute:
      SystemIntegrationsApiClientsClientIdRoute,
    SystemIntegrationsApiClientsIndexRoute:
      SystemIntegrationsApiClientsIndexRoute,
  }

const SystemIntegrationsApiClientsRouteWithChildren =
  SystemIntegrationsApiClientsRoute._addFileChildren(
    SystemIntegrationsApiClientsRouteChildren,
  )

interface SystemIntegrationsSchedulesRouteChildren {
  SystemIntegrationsSchedulesIndexRoute: typeof SystemIntegrationsSchedulesIndexRoute
  SystemIntegrationsSchedulesScheduleIdRunsRoute: typeof SystemIntegrationsSchedulesScheduleIdRunsRoute
}

const SystemIntegrationsSchedulesRouteChildren: SystemIntegrationsSchedulesRouteChildren =
  {
    SystemIntegrationsSchedulesIndexRoute:
      SystemIntegrationsSchedulesIndexRoute,
    SystemIntegrationsSchedulesScheduleIdRunsRoute:
      SystemIntegrationsSchedulesScheduleIdRunsRoute,
  }

const SystemIntegrationsSchedulesRouteWithChildren =
  SystemIntegrationsSchedulesRoute._addFileChildren(
    SystemIntegrationsSchedulesRouteChildren,
  )

interface SystemIntegrationsWebhooksRouteChildren {
  SystemIntegrationsWebhooksWebhookIdDeliveriesRoute: typeof SystemIntegrationsWebhooksWebhookIdDeliveriesRoute
}

const SystemIntegrationsWebhooksRouteChildren: SystemIntegrationsWebhooksRouteChildren =
  {
    SystemIntegrationsWebhooksWebhookIdDeliveriesRoute:
      SystemIntegrationsWebhooksWebhookIdDeliveriesRoute,
  }

const SystemIntegrationsWebhooksRouteWithChildren =
  SystemIntegrationsWebhooksRoute._addFileChildren(
    SystemIntegrationsWebhooksRouteChildren,
  )

interface SystemNotificationsMessagesRouteChildren {
  SystemNotificationsMessagesMessageIdRoute: typeof SystemNotificationsMessagesMessageIdRoute
  SystemNotificationsMessagesIndexRoute: typeof SystemNotificationsMessagesIndexRoute
}

const SystemNotificationsMessagesRouteChildren: SystemNotificationsMessagesRouteChildren =
  {
    SystemNotificationsMessagesMessageIdRoute:
      SystemNotificationsMessagesMessageIdRoute,
    SystemNotificationsMessagesIndexRoute:
      SystemNotificationsMessagesIndexRoute,
  }

const SystemNotificationsMessagesRouteWithChildren =
  SystemNotificationsMessagesRoute._addFileChildren(
    SystemNotificationsMessagesRouteChildren,
  )

interface SystemNotificationsNoticesRouteChildren {
  SystemNotificationsNoticesNoticeIdRoute: typeof SystemNotificationsNoticesNoticeIdRoute
  SystemNotificationsNoticesIndexRoute: typeof SystemNotificationsNoticesIndexRoute
}

const SystemNotificationsNoticesRouteChildren: SystemNotificationsNoticesRouteChildren =
  {
    SystemNotificationsNoticesNoticeIdRoute:
      SystemNotificationsNoticesNoticeIdRoute,
    SystemNotificationsNoticesIndexRoute: SystemNotificationsNoticesIndexRoute,
  }

const SystemNotificationsNoticesRouteWithChildren =
  SystemNotificationsNoticesRoute._addFileChildren(
    SystemNotificationsNoticesRouteChildren,
  )

interface SystemSecurityEventsRouteChildren {
  SystemSecurityEventsEventIdRoute: typeof SystemSecurityEventsEventIdRoute
  SystemSecurityEventsIndexRoute: typeof SystemSecurityEventsIndexRoute
}

const SystemSecurityEventsRouteChildren: SystemSecurityEventsRouteChildren = {
  SystemSecurityEventsEventIdRoute: SystemSecurityEventsEventIdRoute,
  SystemSecurityEventsIndexRoute: SystemSecurityEventsIndexRoute,
}

const SystemSecurityEventsRouteWithChildren =
  SystemSecurityEventsRoute._addFileChildren(SystemSecurityEventsRouteChildren)

interface SystemStorageFilesRouteChildren {
  SystemStorageFilesFileIdRoute: typeof SystemStorageFilesFileIdRoute
  SystemStorageFilesIndexRoute: typeof SystemStorageFilesIndexRoute
}

const SystemStorageFilesRouteChildren: SystemStorageFilesRouteChildren = {
  SystemStorageFilesFileIdRoute: SystemStorageFilesFileIdRoute,
  SystemStorageFilesIndexRoute: SystemStorageFilesIndexRoute,
}

const SystemStorageFilesRouteWithChildren =
  SystemStorageFilesRoute._addFileChildren(SystemStorageFilesRouteChildren)

interface SystemUsersAccountsRouteChildren {
  SystemUsersAccountsUserIdRoute: typeof SystemUsersAccountsUserIdRoute
  SystemUsersAccountsIndexRoute: typeof SystemUsersAccountsIndexRoute
}

const SystemUsersAccountsRouteChildren: SystemUsersAccountsRouteChildren = {
  SystemUsersAccountsUserIdRoute: SystemUsersAccountsUserIdRoute,
  SystemUsersAccountsIndexRoute: SystemUsersAccountsIndexRoute,
}

const SystemUsersAccountsRouteWithChildren =
  SystemUsersAccountsRoute._addFileChildren(SystemUsersAccountsRouteChildren)

interface SystemUsersTenantsRouteChildren {
  SystemUsersTenantsTenantIdRoute: typeof SystemUsersTenantsTenantIdRoute
  SystemUsersTenantsIndexRoute: typeof SystemUsersTenantsIndexRoute
}

const SystemUsersTenantsRouteChildren: SystemUsersTenantsRouteChildren = {
  SystemUsersTenantsTenantIdRoute: SystemUsersTenantsTenantIdRoute,
  SystemUsersTenantsIndexRoute: SystemUsersTenantsIndexRoute,
}

const SystemUsersTenantsRouteWithChildren =
  SystemUsersTenantsRoute._addFileChildren(SystemUsersTenantsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  R403Route: R403Route,
  R404Route: R404Route,
  R500Route: R500Route,
  DashboardRoute: DashboardRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  OfflineRoute: OfflineRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  AppApplicationsRoute: AppApplicationsRoute,
  AppCommerceRoute: AppCommerceRoute,
  AppFeedbacksRoute: AppFeedbacksRoute,
  AppUpgradeCenterRoute: AppUpgradeCenterRoute,
  AppUsersRoute: AppUsersRoute,
  ProfileBasicRoute: ProfileBasicRoute,
  ProfileConnectionsRoute: ProfileConnectionsRoute,
  ProfileSecurityRoute: ProfileSecurityRoute,
  AppContentArticlesRoute: AppContentArticlesRoute,
  AppContentCategoriesRoute: AppContentCategoriesRoute,
  AppContentPagesRoute: AppContentPagesRoute,
  AppSupportCharactersRoute: AppSupportCharactersRoute,
  AppSupportFaqRoute: AppSupportFaqRoute,
  AppSupportInboxRoute: AppSupportInboxRoute,
  AppSupportProductsRoute: AppSupportProductsRoute,
  AppSupportSettingsRoute: AppSupportSettingsRoute,
  AppSupportSitesRoute: AppSupportSitesRoute,
  AuthCallbackProviderRoute: AuthCallbackProviderRoute,
  SystemAccessMenusRoute: SystemAccessMenusRoute,
  SystemAccessPermissionsRoute: SystemAccessPermissionsRoute,
  SystemAccessRolesRoute: SystemAccessRolesRouteWithChildren,
  SystemAiAccessRoute: SystemAiAccessRoute,
  SystemAiModelsRoute: SystemAiModelsRoute,
  SystemAiPlaygroundRoute: SystemAiPlaygroundRoute,
  SystemAiProvidersRoute: SystemAiProvidersRoute,
  SystemAiUsageRoute: SystemAiUsageRoute,
  SystemContentArticlesRoute: SystemContentArticlesRoute,
  SystemContentCategoriesRoute: SystemContentCategoriesRoute,
  SystemIntegrationsApiClientsRoute:
    SystemIntegrationsApiClientsRouteWithChildren,
  SystemIntegrationsSchedulesRoute:
    SystemIntegrationsSchedulesRouteWithChildren,
  SystemIntegrationsWebhooksRoute: SystemIntegrationsWebhooksRouteWithChildren,
  SystemMobileReleasesRoute: SystemMobileReleasesRoute,
  SystemMonitoringHealthRoute: SystemMonitoringHealthRoute,
  SystemMonitoringSessionsRoute: SystemMonitoringSessionsRoute,
  SystemNotificationsDeliveriesRoute: SystemNotificationsDeliveriesRoute,
  SystemNotificationsMessagesRoute:
    SystemNotificationsMessagesRouteWithChildren,
  SystemNotificationsNoticesRoute: SystemNotificationsNoticesRouteWithChildren,
  SystemNotificationsOperationsRoute: SystemNotificationsOperationsRoute,
  SystemNotificationsPushChannelsRoute: SystemNotificationsPushChannelsRoute,
  SystemNotificationsTemplatesRoute: SystemNotificationsTemplatesRoute,
  SystemSecurityBlockRulesRoute: SystemSecurityBlockRulesRoute,
  SystemSecurityEventsRoute: SystemSecurityEventsRouteWithChildren,
  SystemSecurityLoginLogsRoute: SystemSecurityLoginLogsRoute,
  SystemSecurityOperationLogsRoute: SystemSecurityOperationLogsRoute,
  SystemSettingsConfigsRoute: SystemSettingsConfigsRoute,
  SystemSettingsDictionariesRoute: SystemSettingsDictionariesRoute,
  SystemSettingsLoginProvidersRoute: SystemSettingsLoginProvidersRoute,
  SystemSettingsRegionsRoute: SystemSettingsRegionsRoute,
  SystemSettingsShareConfigsRoute: SystemSettingsShareConfigsRoute,
  SystemStorageFilesRoute: SystemStorageFilesRouteWithChildren,
  SystemUsersAccountsRoute: SystemUsersAccountsRouteWithChildren,
  SystemUsersDepartmentsRoute: SystemUsersDepartmentsRoute,
  SystemUsersPositionsRoute: SystemUsersPositionsRoute,
  SystemUsersTenantsRoute: SystemUsersTenantsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
